export enum FinancialLimitFrequency {
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  ALL_TIME = 'ALL_TIME',
}

enum UserRole {
  PURCHASER = 'PURCHASER',
  ORDER_CLEARER = 'ORDER_CLEARER',
  PAYER = 'PAYER',
  PAYMENT_CLEARER = 'PAYMENT_CLEARER',
  APPROVER = 'APPROVER',
  VIEWER = 'VIEWER',
}

interface UserAssignment {
  user: number;
  user_role: UserRole;
  is_role_default: boolean;
  approver_limit: string | null;
}

interface FormFieldAssignment {
  field: number;
  is_mandatory: boolean;
}

interface ClearingGroupAssignment {
  display_order: number;
  name: string;
  assignees: number[];
}

export interface CreateCustomerPayload {
  name: string;
  legal_name: string;
  customer_limit: number;
  auto_approval_limit: number;
  financial_limit_frequency: FinancialLimitFrequency;
  legal_notes?: string;
  terms_and_conditions?: string;
  email?: string;
  phone_number?: string;
  address?: string;
  avatar?: File;
  is_order_and_payment_restrict: boolean;
  user_assignments: UserAssignment[];
  order_fields: FormFieldAssignment[];
  payment_fields: FormFieldAssignment[];
  order_clearing_groups?: ClearingGroupAssignment[];
  payment_clearing_groups?: ClearingGroupAssignment[];
}
